import styled from 'styled-components';

export const CustomDropdownStyled = styled.div.attrs({
  className: 'CustomDropdown',
})`
  width: ${(props) => props.dropdownWidth}%;
`;
